"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlagsEnum;
(function (FeatureFlagsEnum) {
    FeatureFlagsEnum[FeatureFlagsEnum["SendExpectedFundingJournalToTechone"] = 1] = "SendExpectedFundingJournalToTechone";
    FeatureFlagsEnum[FeatureFlagsEnum["SendAdjustmentFundingJournalToTechone"] = 2] = "SendAdjustmentFundingJournalToTechone";
    FeatureFlagsEnum[FeatureFlagsEnum["EnableAgedCareServiceIntegration"] = 3] = "EnableAgedCareServiceIntegration";
    FeatureFlagsEnum[FeatureFlagsEnum["EnableLeaveDateAsDepartureAndAdmissionDateForIntegration"] = 4] = "EnableLeaveDateAsDepartureAndAdmissionDateForIntegration";
    FeatureFlagsEnum[FeatureFlagsEnum["EnableResidentAnaccsToBeFetchedViaIndividualHangfireJobs"] = 5] = "EnableResidentAnaccsToBeFetchedViaIndividualHangfireJobs";
    FeatureFlagsEnum[FeatureFlagsEnum["EnableAgedCareAct2025"] = 6] = "EnableAgedCareAct2025";
    FeatureFlagsEnum[FeatureFlagsEnum["EnablePBRC"] = 7] = "EnablePBRC";
    FeatureFlagsEnum[FeatureFlagsEnum["EnableDMF"] = 8] = "EnableDMF";
})(FeatureFlagsEnum = exports.FeatureFlagsEnum || (exports.FeatureFlagsEnum = {}));
